import { createSlice } from '@reduxjs/toolkit';
import { ABClient } from 'apiClient';
import AxiosClient from 'apiClient/apiClient';
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';

const refreshElastic = createSlice({
    name: 'refreshElastic',
    initialState: {},
    reducers: {
        setIsLoading(state, action) {
            state[action.payload.field] = action.payload.isLoading;
        }
    }
});

export default refreshElastic.reducer;

export const { setIsLoading } = refreshElastic.actions;

export const refreshElasticData = (baseUrl, refershModule, code) => {
    const BASE_URL = baseUrl || ARYABHATTA_API_DOMAIN_V1;

    return async (dispatch) => {
        if (code) {
            dispatch(setIsLoading({ field: refershModule, isLoading: true }));

            const url = AxiosClient.urlParamsMaker(`${BASE_URL}refresh/${refershModule}/`, [['code', code]]);

            const { hasErr } = ABClient.get(url);

            dispatch(setIsLoading({ field: refershModule, isLoading: false }));

            if (hasErr) {
                console.error('Error occurred at ', { refershModule, code });
            }
        }
    };
};
